'use client';

import Link from 'next/link';
import React from 'react';
import { BiChevronLeft } from 'react-icons/bi';

import cn from '@/lib/clsxm';

import Label from '@/components/@base/breadcrumb/label';
import Props from '@/components/@base/breadcrumb/type';
import Container from '@/components/@base/container';
import List, { ListItem } from '@/components/@base/list';
import { useBreadcrumbGenerator } from '@/components/shared/helpers/hooks/breadcrumb-generator';

import { DATA_CY_BREAD_CRUMB } from '@/constant/cypress';

export default function Breadcrumb({
  separator = <BiChevronLeft color='#DFC7A1' />,
  className,
  labelClassName,
  excludeRoutes,
  customBreadCrumbList,
  customPath,
  customLabels,
}: Props) {
  //TODO: make breadcrumb a server component and don't use hooks
  const breadcrumbs =
    customBreadCrumbList && customBreadCrumbList?.length > 0
      ? customBreadCrumbList
      : useBreadcrumbGenerator({
          excludeRoutes,
          customPath,
          customLabels,
        });
  return (
    <List className={cn('flex items-center gap-2', className)}>
      {breadcrumbs?.map(({ label, url, active }, index: number) => (
        <React.Fragment key={`breadcrumb-${index}`}>
          {index > 0 && <ListItem key={`separator-${index}`}>{separator}</ListItem>}
          <ListItem key={`list-item-${index}`}>
            {url ? (
              <Link prefetch={false}
              data-cy={DATA_CY_BREAD_CRUMB}
                href={url}
                className={cn(
                  'text-[13px] font-bold',
                  active && 'text-[#4e4d4d]',
                  labelClassName,
                )}
              >
                {label}
              </Link>
            ) : (
              <Label className={cn('text-[13px] font-bold', labelClassName)} active={active}>
                {label}
              </Label>
            )}
          </ListItem>
        </React.Fragment>
      ))}
    </List>
  );
}
